import { AxiosInstance } from 'axios';
import { DataResponse, PayloadRequest } from '../store/services/requestScreen/TypesRequestScreen';
import { ServiceBaseConfig } from './Interfaces/IAccountService';
import { ICompanyDocumentsResponse, ICompanyFolders, ICompanyFoldersResponse, ICompanyTemplates, PayloadCreateFolder, PayloadUploadDocument, UploadDocumentInput, ICompanyFolderDocumentsResponse } from './Interfaces/IFolderService';

export class FolderService {

  public static async getCompanyFolders(
    api: AxiosInstance,
    companySlug: string | number,
    config: ServiceBaseConfig
  ): Promise<ICompanyFolders> {
    const response = await api.get(`/companies/${companySlug}/folders`, config);
    return response.data.data.data;

  }

  public static async getCompanyDocumentsInFolder(
    api: AxiosInstance,
    companySlug: string | number | undefined,
    folder_id: string,
    config: ServiceBaseConfig
  ): Promise<ICompanyDocumentsResponse> {
    const response = await api.get(`/companies/${companySlug}/folders/${folder_id}/documents`, config);
    return response.data.data;
  }

  public static async getCompanyDocumentsInFolderAlias(
    api: AxiosInstance,
    companySlug: string | number | undefined,
    alias: string,
    config: ServiceBaseConfig
  ): Promise<ICompanyDocumentsResponse> {
    const response = await api.get(`/companies/${companySlug}/folders/alias/${alias}/documents`, config);
    return response.data.data;
  }

  // public static async getCompanyAllDocuments(
  //   api: AxiosInstance,
  //   companySlug: string | number | undefined,
  //   config: ServiceBaseConfig
  // ): Promise<ICompanyDocumentsResponse> {
  //   const response = await api.get(`/companies/${companySlug}/documents/all?per_page=15`, config);
  //   return response.data.data;
  // }

  public static async getCompanyAllDocuments(
  api: AxiosInstance,
  companySlug: string | number | undefined,
  config: ServiceBaseConfig
): Promise<ICompanyDocumentsResponse> {
  // Axios vai juntar: `/...?per_page=15` + `&page=2`
  const response = await api.get(
    `/companies/${companySlug}/documents/all?per_page=10`,
    config
  );
  return response.data.data;
}

  public static async getCompanyFolderDocuments(
    api: AxiosInstance,
    companySlug: string | number | undefined,
    config: ServiceBaseConfig
  ): Promise<ICompanyFolderDocumentsResponse> {
    console.log('🚀 Calling API: GET /companies/' + companySlug + '/folder-documents');
    
    const response = await api.get(
      `/companies/${companySlug}/folder-documents`,
      config
    );
    
    console.log('📥 API Response status:', response.status, '- Data:', response.data);
    return response.data;
  }

  public static async customerCreateFolder(
    api: AxiosInstance,
    payload: PayloadCreateFolder,
    config: ServiceBaseConfig
  ): Promise<ICompanyFoldersResponse> {
    const { data } = await api.post('/companies/folders', payload, config);

    return data;
  }

  public static async customerUploadDocument(
    api: AxiosInstance,
    payload: PayloadUploadDocument,
    config: ServiceBaseConfig
  ): Promise<any> {
    const formData = new FormData();

    if (payload.folder_id !== undefined) {
      formData.append('documents[0][folder_id]', payload.folder_id ?? '');
    }

    formData.append('documents[0][document]', payload.document);
    formData.append('documents[0][name]', payload.document.name);
    formData.append('documents[0][agent_can_view]', String(+payload.agent_can_view));
    formData.append('documents[0][agent_can_manage]', String(+payload.agent_can_manage));

    const { data } = await api.post('/companies/documents', formData, {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }

  public static async agentUploadMultipleDocuments(
    api: AxiosInstance,
    documents: UploadDocumentInput[],
    config: ServiceBaseConfig
  ): Promise<any> {
    const formData = new FormData();

    documents.forEach((doc, index) => {
      formData.append(`documents[${index}][company_id]`, String(doc.company_id));
      formData.append(`documents[${index}][template]`, doc.template);
      formData.append(`documents[${index}][document]`, doc.document);
      formData.append(`documents[${index}][customer_can_view]`, String(+doc.customer_can_view));
      formData.append(`documents[${index}][customer_can_manage]`, String(+doc.customer_can_manage));
      formData.append(`documents[${index}][requires_signature ]`, '0');
      
      if (doc.issue_date) {
        formData.append(`documents[${index}][issue_date]`, String(doc.issue_date))
      }

      if (doc.document_template_alias) 
        formData.append(`documents[${index}][document_template_alias]`, doc.document_template_alias);
     

      if (doc.shareholder_id)
        formData.append(`documents[${index}][shareholder_id]`, String(doc.shareholder_id));
      
    });

    const { data } = await api.post('/companies/documents', formData, {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }




  public static async customerChangeFolderName(
    api: AxiosInstance,
    folder_id: string,
    payload: PayloadCreateFolder,
    config: ServiceBaseConfig
  ): Promise<ICompanyFoldersResponse> {
    const { data } = await api.put(`/companies/folders/${folder_id}`, payload, config);

    return data;
  }

  public static async customerDeleteFolder(
    api: AxiosInstance,
    folder_id: string,
    config: ServiceBaseConfig
  ): Promise<ICompanyFoldersResponse> {
    const { data } = await api.delete(`/companies/folders/${folder_id}`, config);

    return data;
  }

  public static async getCompanyDocuments(
    api: AxiosInstance,
    companySlug: string | number,
    config: ServiceBaseConfig
  ): Promise<ICompanyFolders> {
    const response = await api.get(`/companies/${companySlug}/documents/without-folders`, config);
    return response.data.data.data;
  }

  public static async getCompanyTemplatesDocuments(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<ICompanyTemplates> {
    const response = await api.get('/documents/templates?per_page=20', config);
    console.log(response);
    
    return response.data.data;
  }

  public static async agentCreateFolder(
    api: AxiosInstance,
    payload: PayloadCreateFolder,
    config: ServiceBaseConfig
  ): Promise<ICompanyFoldersResponse> {
    const { data } = await api.post('/folders', payload, config);

    return data;
  }

  public static async agentChangeFolderName(
    api: AxiosInstance,
    folder_id: string,
    payload: PayloadCreateFolder,
    config: ServiceBaseConfig
  ): Promise<ICompanyFoldersResponse> {
    const { data } = await api.put(`/folders/${folder_id}`, payload, config);

    return data;
  }

  public static async agentDeleteFolder(
    api: AxiosInstance,
    folder_id: string,
    config: ServiceBaseConfig
  ): Promise<ICompanyFoldersResponse> {
    const { data } = await api.delete(`/folders/${folder_id}`, config);

    return data;
  }
}
